import React from 'react';
import { Listbox } from '@headlessui/react';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers';

const DateTimePickerInput = ({ label, value, onChange, disabled, maxDate, minDate }) => {
    return (
        <div className="flex flex-col flex-1 w-full space-y-2 min-w-max">
            <Listbox disabled={disabled}>
                <Listbox.Label className="text-lg font-bold text-gray-700 mt-2">
                    {label}
                </Listbox.Label>
                <div className="w-full">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker    
                            className="w-full"
                            value={value}
                            onChange={onChange}
                            renderInput={(params) => <TextField {...params} />}
                            maxDate={maxDate}
                            disabled={disabled}
                            minDate={minDate}
                        ></DateTimePicker>
                    </LocalizationProvider>
                </div>
            </Listbox>
        </div>
    );
};

export default DateTimePickerInput;
